<template>
  <div class="main" ref="DOM">
    <img src="./images/zero_run.jpeg">
    <div class="btn buy" @click="handleGoBuy">我要买车</div>
    <div class="btn rent" @click="handleGoRent">我要租车</div>
  </div>
</template>

<script>
export default {
  name: "zeroRun",
  data() {
    return {
    };
  },
  methods: {
    // 我要买车
    handleGoBuy() {
      this.$router.push('/zeroRun/zeroRunBuyCar');
    },
    // 我要租车
    handleGoRent() {
      // 线上商品
      window.location.href = 'https://app5.shouqiev.com/dist/#/goTicket_new/Details?commoditiesId=a174c9698c1043ccac387ee2c058a19b&shelvesId=d8bce31162254fb38216c525c4ac8e69&salesClassification=5&goodsName=代金券&preferentialPrice=9.9&index=0&positionY=0';
      // 预发布商品
      // window.location.href = "https://preapp5.shouqiev.com/dist/#/goTicket_new/Details?commoditiesId=761607ddbc034d9bab1b8cd36de42158&shelvesId=647128d52a3b4dafa93c82f32bf3504e&salesClassification=11&goodsName=%E4%BB%BD%E6%97%A5%E6%95%B4&preferentialPrice=0.01&index=0&positionY=0";
      // 测试商品
      // window.location.href = 'http://app520.51gofunev.com/dist/#/goTicket_new/Details?commoditiesId=6194ecc8ac53459d9ceae82f51d9e219&shelvesId=2485af8ab244492eb5ce439867855a7e&salesClassification=1&goodsName=111&preferentialPrice=0.03&index=0&positionY=0';
    }
  }
};
</script>

<style scoped lang="scss">
.main {
  position: relative;
  img {
    width: 100%;
  }
  .btn {
    width: 285px;
    height: 84px;
    position: absolute;
    bottom: 212px;
    opacity: 0;
  }
  .buy {
    left: 79px;
  }
  .rent {
    right: 70px;
  }
}
</style>
